const baseURL = process.env.VUE_APP_API_BASE || '/api'
//  const baseURL = 'https://aomen.tgboty.top/api' 
export default {
  baseURL
}
